document.addEventListener('DOMContentLoaded', function () {
    const blockHalfTextPortfolio = document.querySelectorAll('.block-half-text-portfolio');

    if (blockHalfTextPortfolio.length === 0) return;
    if (typeof gsap === 'undefined') return;

    if (typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
    }

    // Loop through each block-half-text-portfolio section
    blockHalfTextPortfolio.forEach(function (blockHalfTextPortfolio) {
        const blockHalfTextPortfolioHeading = blockHalfTextPortfolio.querySelector('.block-half-text-portfolio__heading');
        const blockHalfTextPortfolioContent = blockHalfTextPortfolio.querySelector('.block-half-text-portfolio__content');
        const blockHalfTextPortfolioImage = blockHalfTextPortfolio.querySelector('.block-half-text-portfolio__picture');
        const blockHalfTextPortfolioVideo = blockHalfTextPortfolio.querySelector('.block-half-text-portfolio__video');

        // Check if the heading element exists
        if (blockHalfTextPortfolioHeading) {
            gsap.fromTo(blockHalfTextPortfolioHeading, {
                autoAlpha: 0,
                x: -60,
            }, {
                autoAlpha: 1,
                x: 0,
                duration: 0.6,
                ease: 'power3.out',
                scrollTrigger: typeof ScrollTrigger !== 'undefined' ? {
                    trigger: blockHalfTextPortfolio,
                    start: 'top 80%',
                    once: true,
                } : null,
            });
        }

        // Check if the content element exists
        if (blockHalfTextPortfolioContent) {
            gsap.fromTo(blockHalfTextPortfolioContent, {
                autoAlpha: 0,
                x: -60,
            }, {
                autoAlpha: 1,
                x: 0,
                duration: 0.6,
                ease: 'power3.out',
                scrollTrigger: typeof ScrollTrigger !== 'undefined' ? {
                    trigger: blockHalfTextPortfolio,
                    start: 'top 80%',
                    once: true,
                } : null,
            });
        }

        // Check if the image element exists
        if (blockHalfTextPortfolioImage) {
            gsap.fromTo(blockHalfTextPortfolioImage, {
                autoAlpha: 0,
                x: 60,
            }, {
                autoAlpha: 1,
                x: 0,
                duration: 0.6,
                ease: 'power3.out',
                scrollTrigger: typeof ScrollTrigger !== 'undefined' ? {
                    trigger: blockHalfTextPortfolio,
                    start: 'top 80%',
                    once: true,
                } : null,
            });
        }

        // Check if the video element exists
        if (blockHalfTextPortfolioVideo) {
            gsap.fromTo(blockHalfTextPortfolioVideo, {
                autoAlpha: 0,
                x: 60,
            }, {
                autoAlpha: 1,
                x: 0,
                duration: 0.6,
                ease: 'power3.out',
                scrollTrigger: typeof ScrollTrigger !== 'undefined' ? {
                    trigger: blockHalfTextPortfolio,
                    start: 'top 80%',
                    once: true,
                } : null,
            });
        }

    });
});
